import { render, staticRenderFns } from "./OrganizationJson.vue?vue&type=template&id=a4f89e80&"
import script from "./OrganizationJson.vue?vue&type=script&lang=js&"
export * from "./OrganizationJson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports